module.exports = __webpack_public_path__ + "img/tip.68b51489.svg";